import { useEffect } from "react"
import PropTypes from "prop-types"
import { capitalize, noop } from "lodash"
import { getFactorRiskColumns } from "helpers/factor-view"
import { DATE } from "helpers/shapes"
import AnalyzeFactorsContent from "components/analyze-factors-content"

export default function AnalyzeFactorsRisk({ selectedFactorCategory, totalRow, factors, categories, setFactorCategory, status, setLoaded = noop, selectedDate, isComposite, filtersVisible, currency, scales }) {
  useEffect(() => {
    setLoaded(status === "ok")
    // on unmount, set loaded back to false
    return () => setLoaded(false)
  }, [status, setLoaded])

  const titlePrefix = `${capitalize(selectedFactorCategory)}${selectedFactorCategory !== "factors" ? " factors" : ""}`

  return <AnalyzeFactorsContent {...{
    type: "risk",
    titlePrefix,
    totalRow,
    columns: getFactorRiskColumns("table", isComposite, currency, scales),
    totalColumns: getFactorRiskColumns("total", isComposite, currency, scales),
    categoriesColumns: getFactorRiskColumns("categories", isComposite, currency, scales),
    factors,
    categories,
    selectedFactorCategory,
    setFactorCategory,
    selectedDate,
    filtersVisible,
  }}
  />
}

AnalyzeFactorsRisk.propTypes = {
  selectedView: PropTypes.string.isRequired,
  selectedFactorCategory: PropTypes.string.isRequired,
  totalRow: PropTypes.array.isRequired,
  factors: PropTypes.array.isRequired,
  categories: PropTypes.array.isRequired,
  setFactorCategory: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  status: PropTypes.string.isRequired,
  setLoaded: PropTypes.func,
  selectedDate: DATE,
  isComposite: PropTypes.bool,
  filtersVisible: PropTypes.bool,
  currency: PropTypes.string,
  scales: PropTypes.shape({
    valueAtRisk: PropTypes.string,
    currencyExposure: PropTypes.string,
    predictedRisk: PropTypes.string,
  }),
}
